type Props = Readonly<{
  description: React.ReactNode;
  children: React.ReactNode;
}>;

export function SummaryCard({ children, description }: Props): JSX.Element {
  return (
    <div
      className={
        "flex flex-col flex-shrink-0 flex-grow-0 border border-primary bg-secondary round relative overflow-x-auto scroll-smooth overscroll-contain"
      }
    >
      <div className="flex flex-col py-3 px-6">
        <div className="flex flex-row items-center">
          <div>
            <span className="block text-gray-500 dark:text-gray-400 mb-3">
              {description}
            </span>
            <div className="text-2xl font-semibold text-black dark:text-white mr-6">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
